import React from "react";

export default function GoalProgressCard({ goalProgress, dailyGoal, handleGoalChange }) {
  const radius = 38;
  const stroke = 5.5;
  const normalizedRadius = radius - stroke * 2;
  const circumference = normalizedRadius * 2 * Math.PI;
  
  const cappedPercent = Math.min(100, Math.max(0, goalProgress.percent));
  const strokeDashoffset = circumference - (cappedPercent / 100) * circumference;

  const isCompleted = goalProgress.pagesReadToday >= goalProgress.goal;

  return (
    <div style={{
      background: "var(--white)",
      border: "1px solid var(--dust)",
      borderRadius: "16px",
      padding: "1.75rem",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      boxShadow: "var(--shadow)",
      transition: "background 0.3s ease, border-color 0.3s ease",
      gap: "2rem",
      flexWrap: "wrap",
    }}>
      <div style={{ display: "flex", alignItems: "center", gap: "1.25rem" }}>
        {/* Progress Ring with Centered Text */}
        <div style={{ 
          position: "relative", 
          width: radius * 2, 
          height: radius * 2, 
          display: "flex", 
          alignItems: "center", 
          justifyContent: "center",
          flexShrink: 0 
        }}>
          <svg height={radius * 2} width={radius * 2} style={{ transform: "rotate(-90deg)", position: "absolute", top: 0, left: 0 }}>
            <circle stroke="var(--dust)" fill="transparent" strokeWidth={stroke} r={normalizedRadius} cx={radius} cy={radius} />
            <circle
              stroke="url(#goldGrad)"
              fill="transparent"
              strokeWidth={stroke}
              strokeDasharray={circumference + " " + circumference}
              style={{ strokeDashoffset, transition: "stroke-dashoffset 0.5s ease" }}
              r={normalizedRadius}
              cx={radius}
              cy={radius}
            />
            <defs>
              <linearGradient id="goldGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="var(--gold)" />
                <stop offset="100%" stopColor="var(--gold)" stopOpacity="0.85" />
              </linearGradient>
            </defs>
          </svg>
          
          <div style={{
            fontSize: "0.85rem",
            fontWeight: 700,
            color: "var(--ink)",
            fontFamily: "'Outfit', sans-serif",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            lineHeight: 1,
          }}>
            <span>{Math.round(goalProgress.percent)}%</span>
          </div>
        </div>

        <div>
          <div style={{
            fontFamily: "'Outfit', sans-serif",
            fontSize: "0.7rem",
            color: "var(--muted)",
            textTransform: "uppercase",
            letterSpacing: "0.08em",
            fontWeight: 600,
          }}>
            Daily Goal Progress
          </div>
          <h3 style={{
            fontFamily: "'Outfit', sans-serif",
            fontSize: "1.65rem",
            fontWeight: 800,
            color: "var(--ink)",
            margin: "2px 0",
            display: "flex",
            alignItems: "baseline",
            gap: "4px",
          }}>
            {goalProgress.pagesReadToday}
            <span style={{ fontSize: "1rem", color: "var(--muted)", fontWeight: 400 }}>/ {goalProgress.goal} pages</span>
          </h3>
          <div style={{ 
            fontSize: "0.8rem", 
            color: isCompleted ? "var(--sage)" : "var(--muted)",
            fontWeight: isCompleted ? 600 : 500,
            display: "flex",
            alignItems: "center",
            gap: "4px",
          }}>
            {isCompleted ? "✨ Daily goal achieved!" : `📖 ${goalProgress.goal - goalProgress.pagesReadToday} pages left today`}
          </div>
        </div>
      </div>
    </div>
  );
}
